import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThunder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThunder"><Path d="M15.5235 0.188477L2.82812 14.9998H9.83673L8.48115 23.8111L21.1766 8.9998H14.168L15.5235 0.188477Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThunder;
